module.exports = __webpack_public_path__ + "static/img/yunmu.efd746d2.png";